import { render } from "./index.vue?vue&type=template&id=3cb4af03&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=3cb4af03&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb4af03"]])

export default __exports__